import { Routes } from "@angular/router";

import { SwipePageComponent } from "./pages/swipe-page/swipe-page.component";
import { ChatPageComponent } from "./pages/chat-page/chat-page.component";
import { AboutPageComponent } from "./pages/about-page/about-page.component";
import { CompatibilityQuizPageComponent } from "./pages/compatibility-quiz-page/compatibility-quiz-page.component";

export const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "swipe" },
  { path: "swipe", component: SwipePageComponent },
  { path: "chat", component: ChatPageComponent },
  { path: "about", component: AboutPageComponent },
  { path: "quiz", component: CompatibilityQuizPageComponent },
  { path: "**", redirectTo: "swipe" }
];

